import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, Mail } from 'lucide-react';
import { useI18n } from '../../i18n/I18nContext';
import './Contact.css';

const Contact: React.FC = () => {
  const { content } = useI18n();
  const contact = content.contact;
  return (
    <section className="contact section" aria-label={contact.aria}>
      <div className="container contact__grid">
        <a href="mailto:hello@assetfactory.app" className="contact__card">
          <span className="contact__icon"><Mail size={20} strokeWidth={1.7} /></span>
          <div><span className="contact__label">{contact.general}</span><h2>hello@assetfactory.app</h2><p>{contact.generalText}</p></div>
        </a>
        <Link to="/request" className="contact__card">
          <span className="contact__icon"><FileText size={20} strokeWidth={1.7} /></span>
          <div><span className="contact__label">{contact.project}</span><h2>{contact.projectTitle}</h2><p>{contact.projectText}</p></div>
        </Link>
      </div>
    </section>
  );
};

export default Contact;
